import React from 'react';
import {Typography} from '@mui/material';
import {getCurrencyFloat, getCurrencyString} from '../../../utils/currencyFormatter';
import {withdrawalFieldsType} from './builderWithdrawalFields';
import {BuilderPot} from '../../../schema-types/BuilderPot';
import {
  changeWithdrawalSourceFactory,
  changeWithdrawalDestinationFactory,
  loadSavedWithdrawal,
} from '../hooks/builderWithdrawalHooks';

export {
  changeWithdrawalSourceFactory,
  changeWithdrawalDestinationFactory,
  loadSavedWithdrawal,
};

export const getWithdrawalMessageFactory = ({
  withdraw,
}: {
  withdraw: withdrawalFieldsType | undefined;
}) => {
  return (isSelected: boolean) => {
    if (!isSelected) {
      return null;
    }
    return (
      <Typography>
        <strong data-testid="withdraw-message-id">{` - Withdrawal amount ${getCurrencyString(
          Number(withdraw?.source?.singleClientAmount || 0) +
            Number(withdraw?.source.recurringClientAmount || 0)
        )}`}</strong>
      </Typography>
    );
  };
};
export const withdrawalSources = ({
  sourcePots,
  isSppDa,
  reviewId,
}: {
  sourcePots: BuilderPot[];
  isSppDa: boolean;
  reviewId: string;
}): BuilderPot[] => {
  return sourcePots.filter((el) => {
    // Preventing empty accounts from being listed as sources for withdrawals
    // as that would be non-sensical
    if (el.totalValue === '0.00' || !el.totalValue) {
      return false;
    }
    // For SPP, only withdrawal from a plan proposed in OneView, but not submitted, OR from a plan that exists in Curo.
    if (isSppDa) {
      if (el.review?.id === reviewId) {
        return true;
      }
      if (el.curoId) {
        return true;
      }
      return false;
    }
    return true;
  });
};
